import Vue from 'vue'
import Router from 'vue-router'
import OfficialSite from '@/components/OfficialSite'

Vue.use(Router)

function isFilePreviewMode () {
  return typeof window !== 'undefined' && window.location.protocol === 'file:'
}

function getFilePreviewRoute () {
  if (!isFilePreviewMode()) {
    return '/'
  }

  const pathname = decodeURIComponent(window.location.pathname || '').replace(/\\/g, '/')
  const marker = '/dist/'
  const markerIndex = pathname.toLowerCase().lastIndexOf(marker)

  if (markerIndex === -1) {
    return '/'
  }

  const tailPath = pathname
    .slice(markerIndex + marker.length)
    .replace(/^\/+/, '')

  if (!tailPath || /^index\.html$/i.test(tailPath)) {
    return '/'
  }

  return '/' + tailPath
}

if (isFilePreviewMode() && (!window.location.hash || window.location.hash === '#')) {
  window.location.hash = getFilePreviewRoute()
}

function loadAsyncComponent (loader) {
  return function (resolve) {
    loader(function (module) {
      resolve(module.default || module)
    })
  }
}

const AdminLogin = loadAsyncComponent(function (resolve) {
  require.ensure([], function () {
    resolve(require('@/components/AdminLoginEntry'))
  }, 'admin-auth')
})
const AdminConsole = loadAsyncComponent(function (resolve) {
  require.ensure([], function () {
    resolve(require('@/components/AdminConsole'))
  }, 'admin-console')
})
const PlatformAdminLogin = loadAsyncComponent(function (resolve) {
  require.ensure([], function () {
    resolve(require('@/components/PlatformAdminLogin'))
  }, 'platform-auth')
})
const PlatformAdminConsole = loadAsyncComponent(function (resolve) {
  require.ensure([], function () {
    resolve(require('@/components/PlatformAdminConsole'))
  }, 'platform-console')
})
const PlatformOverviewPage = loadAsyncComponent(function (resolve) {
  require.ensure([], function () {
    resolve(require('@/components/platform-admin/pages/PlatformOverviewPage'))
  }, 'platform-console')
})
const PlatformAgentsPage = loadAsyncComponent(function (resolve) {
  require.ensure([], function () {
    resolve(require('@/components/platform-admin/pages/PlatformAgentsPage'))
  }, 'platform-console')
})
const PlatformEnterprisesPage = loadAsyncComponent(function (resolve) {
  require.ensure([], function () {
    resolve(require('@/components/platform-admin/pages/PlatformEnterprisesPage'))
  }, 'platform-console')
})
const PlatformApprovalsPage = loadAsyncComponent(function (resolve) {
  require.ensure([], function () {
    resolve(require('@/components/platform-admin/pages/PlatformApprovalsPage'))
  }, 'platform-console')
})
const PlatformSettlementsPage = loadAsyncComponent(function (resolve) {
  require.ensure([], function () {
    resolve(require('@/components/platform-admin/pages/PlatformSettlementsPage'))
  }, 'platform-console')
})
const PlatformControlPage = loadAsyncComponent(function (resolve) {
  require.ensure([], function () {
    resolve(require('@/components/platform-admin/pages/PlatformControlPage'))
  }, 'platform-console')
})
const PlatformNotificationsPage = loadAsyncComponent(function (resolve) {
  require.ensure([], function () {
    resolve(require('@/components/platform-admin/pages/PlatformNotificationsPage'))
  }, 'platform-console')
})
const PlatformProfilePage = loadAsyncComponent(function (resolve) {
  require.ensure([], function () {
    resolve(require('@/components/platform-admin/pages/PlatformProfilePage'))
  }, 'platform-console')
})
const PlatformPasswordPage = loadAsyncComponent(function (resolve) {
  require.ensure([], function () {
    resolve(require('@/components/platform-admin/pages/PlatformPasswordPage'))
  }, 'platform-console')
})

export default new Router({
  mode: isFilePreviewMode() ? 'hash' : 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'OfficialSite',
      component: OfficialSite,
      meta: {
        title: '数企推 | 企业数字名片、企业官网与线索转化解决方案',
        description: '数企推为企业提供数字名片、手机官网、品牌展示、内容分发与线索转化解决方案，帮助市场、销售、服务与渠道团队统一对外形象并持续获客。',
        robots: 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1'
      }
    },
    {
      path: '/admin/login/index.html',
      name: 'AdminLogin',
      component: AdminLogin,
      meta: {
        title: '后台登录 | 数企推',
        description: '数企推后台登录入口。',
        robots: 'noindex,nofollow,noarchive',
        structuredData: false
      }
    },
    {
      path: '/admin',
      redirect: '/admin/console/index.html'
    },
    {
      path: '/admin/console/index.html',
      name: 'AdminConsole',
      component: AdminConsole,
      meta: {
        title: '管理后台 | 数企推',
        description: '数企推管理后台。',
        robots: 'noindex,nofollow,noarchive',
        structuredData: false
      }
    },
    {
      path: '/platform-admin',
      redirect: '/platform-admin/login/index.html'
    },
    {
      path: '/platform-admin/login/index.html',
      name: 'PlatformAdminLogin',
      component: PlatformAdminLogin,
      meta: {
        title: '平台总后台登录 | 数企推',
        description: '数企推平台管理员登录入口。',
        robots: 'noindex,nofollow,noarchive',
        structuredData: false
      }
    },
    {
      path: '/platform-admin/console/index.html',
      redirect: '/platform-admin/console/overview/index.html'
    },
    {
      path: '/platform-admin/console',
      component: PlatformAdminConsole,
      children: [
        {
          path: 'overview/index.html',
          name: 'PlatformAdminOverview',
          component: PlatformOverviewPage,
          meta: {
            title: '平台概览 | 数企推',
            description: '平台经营指标、预警与操作总览。',
            robots: 'noindex,nofollow,noarchive',
            structuredData: false,
            sectionId: 'overview'
          }
        },
        {
          path: 'agents/index.html',
          name: 'PlatformAdminAgents',
          component: PlatformAgentsPage,
          meta: {
            title: '代理商管理 | 数企推',
            description: '平台管理员管理代理商状态、经营与风险。',
            robots: 'noindex,nofollow,noarchive',
            structuredData: false,
            sectionId: 'agents'
          }
        },
        {
          path: 'enterprises/index.html',
          name: 'PlatformAdminEnterprises',
          component: PlatformEnterprisesPage,
          meta: {
            title: '企业用户 | 数企推',
            description: '平台统一管理企业租户、套餐、续费与停用。',
            robots: 'noindex,nofollow,noarchive',
            structuredData: false,
            sectionId: 'enterprises'
          }
        },
        {
          path: 'approvals/index.html',
          name: 'PlatformAdminApprovals',
          component: PlatformApprovalsPage,
          meta: {
            title: '审核中心 | 数企推',
            description: '平台代理准入、企业认证与变更审批中心。',
            robots: 'noindex,nofollow,noarchive',
            structuredData: false,
            sectionId: 'approvals'
          }
        },
        {
          path: 'settlements/index.html',
          name: 'PlatformAdminSettlements',
          component: PlatformSettlementsPage,
          meta: {
            title: '结算中心 | 数企推',
            description: '平台代理商分润、开票、对账与打款管理。',
            robots: 'noindex,nofollow,noarchive',
            structuredData: false,
            sectionId: 'settlements'
          }
        },
        {
          path: 'control/index.html',
          name: 'PlatformAdminControl',
          component: PlatformControlPage,
          meta: {
            title: '权限风控 | 数企推',
            description: '平台账号、模块状态与安全风控管理。',
            robots: 'noindex,nofollow,noarchive',
            structuredData: false,
            sectionId: 'control'
          }
        },
        {
          path: 'notifications/index.html',
          name: 'PlatformAdminNotifications',
          component: PlatformNotificationsPage,
          meta: {
            title: '通知中心 | 数企推',
            description: '平台通知、提醒与消息详情。',
            robots: 'noindex,nofollow,noarchive',
            structuredData: false,
            viewLabel: '通知中心',
            viewKicker: '消息中心',
            viewShort: 'Notice',
            viewDesc: '查看平台通知、业务提醒、安全消息与详细信息。'
          }
        },
        {
          path: 'profile/index.html',
          name: 'PlatformAdminProfile',
          component: PlatformProfilePage,
          meta: {
            title: '用户信息 | 数企推',
            description: '平台管理员用户信息与权限范围。',
            robots: 'noindex,nofollow,noarchive',
            structuredData: false,
            viewLabel: '用户信息',
            viewKicker: '账号中心',
            viewShort: 'Profile',
            viewDesc: '查看和维护平台管理员资料、权限范围与最近登录信息。'
          }
        },
        {
          path: 'password/index.html',
          name: 'PlatformAdminPassword',
          component: PlatformPasswordPage,
          meta: {
            title: '修改密码 | 数企推',
            description: '平台管理员登录密码与安全设置。',
            robots: 'noindex,nofollow,noarchive',
            structuredData: false,
            viewLabel: '修改密码',
            viewKicker: '账号安全',
            viewShort: 'Password',
            viewDesc: '更新平台管理员登录密码，并同步平台安全策略。'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js